// src/App.tsx
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import NavBar from "./components/Navigation/NavBar";
import { AuthProvider } from "./context/AuthContext"; // if you're using context for auth
import PermissionManagement from "./pages/Admin/PermissionManagement";
import Products from "./pages/Admin/Products";
import RegistrationPage from "./pages/Admin/RegisterPage";
import Stores from "./pages/Admin/Stores";
import Users from "./pages/Admin/Users";
import NotFound from "./pages/Auth/NotFound";
import PrivateRoute from "./pages/Auth/PrivateRoute";
import ClientProducts from "./pages/Client/ClientProducts";
import ClientRequests from "./pages/Client/ClientRequests";
import TradeShowLeadForm from "./pages/Client/RegistrationForm";
import ClientHomePage from "./pages/ClientHomePage";
import HomePage from "./pages/HomePage";
import LeadsList from "./pages/Lead/LeadsList";
import LoginPage from "./pages/LoginPage";
import RequestInventory from "./pages/Store/RequestInventory";
import RequestedProducts from "./pages/Store/RequestedProducts";
import StoreInventory from "./pages/Store/StoreInventory";
import SuperAdminHomePage from "./pages/SuperAdminHomePage";
import WelcomePage from "./pages/WelcomePage";
import DcInventory from "./pages/warehouse/DcInventory";
import InventoryApproval from "./pages/warehouse/InventoryApproval";
import StoreHistory from "./pages/warehouse/StoreHistory";
import StoreRequest from "./pages/warehouse/StoreRequest";
import { RootState } from "./store";
import { setAuthToken } from "./utils/apiClient";
import ClientOrderHistory from "./pages/Client/ClientOrderHistory";
import { useSessionTimeout } from "./Hooks/useSessionTimeout";

export const brandColors = {
  primary: "#03360aff",
  secondary: "#11671cff",
  tertiary: "#239848ff",
  header: "#4C763B",
  highlight: "#3B9797",
  black: "#000000ff",
  white: "#ffffffff",
  gray1: "#d0d0d0ff",
};
const App = () => {
  const token = useSelector((state: RootState) => state?.auth.token);
  const user = useSelector((state: RootState) => state?.auth.user);
  useEffect(() => {
    if (token) {
      setAuthToken(token); // Set token once globally
    }
  }, [token]);
  useSessionTimeout();
  return (
    <AuthProvider>
      {" "}
      {/* Wrap the app with AuthContext if needed */}
      <Router>
        {/* NavBar will be shown across all pages */}
        <NavBar />
        <Routes>
          <Route
            path="/"
            element={
              <PrivateRoute
                page={
                  user?.role === "SuperAdmin" ? (
                    <SuperAdminHomePage />
                  ) : user?.role === "Client" ? (
                    <ClientHomePage />
                  ) : (
                    <HomePage />
                  )
                }
              />
            }
          />
          <Route
            path="/clientInventory"
            element={<PrivateRoute page={<ClientProducts />} />}
          />
          {/* <Route
            path="/orderHistory"
            element={<PrivateRoute page={<ClientOrderHistory />} />}
          /> */}
          <Route
            path="/orderHistory"
            element={<PrivateRoute page={<ClientOrderHistory />} />}
          />
          <Route
            path="/leadsList"
            element={<PrivateRoute page={<LeadsList />} />}
          />
          <Route path="/login" element={<LoginPage />} />
          <Route
            path="/register"
            element={<PrivateRoute page={<RegistrationPage />} />}
          />
          <Route
            path="/permissions"
            element={<PrivateRoute page={<PermissionManagement />} />}
          />
          <Route
            path="/welcome"
            element={<PrivateRoute page={<WelcomePage />} />}
          />
          <Route path="/clientRegistration" element={<TradeShowLeadForm />} />
          {/*Admin*/}
          <Route
            path="/products"
            element={<PrivateRoute page={<Products />} />}
          />
          <Route path="/user" element={<PrivateRoute page={<Users />} />} />
          <Route path="/stores" element={<PrivateRoute page={<Stores />} />} />
          {/*Warehouse*/}
          <Route
            path="/dcinventory"
            element={<PrivateRoute page={<DcInventory />} />}
          />
          <Route
            path="/inventoryApproval"
            element={<PrivateRoute page={<InventoryApproval />} />}
          />
          <Route
            path="/storeRequests"
            element={<PrivateRoute page={<StoreRequest />} />}
          />
          <Route
            path="/clientRequests"
            element={<PrivateRoute page={<ClientRequests />} />}
          />
          <Route
            path="/storeHistory"
            element={<PrivateRoute page={<StoreHistory />} />}
          />
          {/*Store*/}
          <Route
            path="/storeInventory"
            element={<PrivateRoute page={<StoreInventory />} />}
          />
          <Route
            path="/requestInventory"
            element={<PrivateRoute page={<RequestInventory />} />}
          />
          <Route
            path="/requestedProducts"
            element={<PrivateRoute page={<RequestedProducts />} />}
          />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
};

export default App;
